export default {
    Grandstream: [
        {
            id: "GXP1628",
            name: "Grandstream GXP1628 Small Business HD IP Phone",
            vdLink: "",
            price: 85.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=14748",
        },
        {
            id: "GXP2130",
            name: "Grandstream GXP2130v2 3-Line Enterprise HD IP Phone with Bluetooth - Includes Power Supply",
            vdLink: "https://voipdialing.com/equipment/product/details/id/8267",
            price: 99.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=13453",
        },
        {
            id: "GXP2135",
            name: "Grandstream GXP2135 Multi-line High Performance IP Phone",
            vdLink: "",
            price: 115.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=15407",
        },
        {
            id: "GXP2140",
            name: "Grandstream GXP2140 Enterprise 4-Line IP Phone",
            vdLink: "https://voipdialing.com/equipment/product/details/id/7876",
            price: 139.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=12930",
        },
        {
            id: "GXP2160",
            name: "Grandstream GXP2160 Enterprise 6-Line IP Phone",
            vdLink: "https://voipdialing.com/equipment/product/details/id/7877",
            price: 159.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=12934",
        },
    ],
    Yealink: [
        {
            id: "SIP-T29G",
            name: "Yealink SIP-T29G Professional Gigabit phone with Color LCD - Includes Power Supply",
            vdLink: "",
            price: 244.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=14784",
        },
        {
            id: "SIP-T46S",
            name: "Yealink SIP-T46S IP Phone (PoE) - With Power Supply",
            vdLink: "",
            price: 284.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=17201",
        },
    ],
    Polycom: [
        {
            id: "VVX401",
            name: "Polycom VVX 401 12-line Desktop Phone Skype for Business Edition - with Power Supply",
            vdLink: "",
            price: 299.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=18754",
        },
        {
            id: "VVX101",
            name: "Polycom VVX 101 Business Media Phone (PoE) - with Power Supply",
            vdLink: "",
            price: 134.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=14816",
        },
    ],
    Cisco: [
        {
            id: "SPA525G2",
            name: "Cisco SPA525G2 5-Line IP Phone - Graphics-rich, High-resolution 3.2-inch QVGA 320 x 240 Color Screen",
            vdLink: "https://voipdialing.com/equipment/product/details/id/2879",
            price: 365.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=16566",
        },
        {
            id: "SPA501G",
            name: "Cisco SPA501G Basic 8-Line IP Phone",
            vdLink: "https://voipdialing.com/equipment/product/details/id/2869",
            price: 135.00,
            providerLink: "https://netxusa.com/products.php?view=product&path=manufacturer&pindex=5622",
        },
    ]
}
